import { render, staticRenderFns } from "./ModalRoles.vue?vue&type=template&id=6c20063c"
import script from "./ModalRoles.vue?vue&type=script&lang=js"
export * from "./ModalRoles.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports